<template>
  <naj-modal
    ref="renderJudgementDetailsModal"
    :width="1000"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    :title="`${modalTitle}`"
    content-class="judgement-details-contents"
    @onClose="closeRenderJudgementDetailsModal"
  >
    <div v-if="loading" class="loader-holder">
      <naj-loader></naj-loader>
    </div>
    <div>
      <naj-box v-if="judgementDetails.documentId" :title="local.home.judgementDelivery.judgementDetails">
        <naj-data-table
          no-header
          disable-items-per-page
          :headers="deliveryHeaders"
          :loading="loading"
          :items="judgementDetails ? [judgementDetails] : []"
          :no-margin-bottom="false"
          :skip-casting-enabled="true"
          :skip-casting-keys="['conclusiveDate']"
        ></naj-data-table>
      </naj-box>
    </div>

    <naj-box v-if="judgementDetails.documentId" :title="local.home.judgementDelivery.judgement">
      <template class="attachment-row">
        <div v-if="document !== null" class="pdf-container">
          <div class="pdf-wrapper">
            <div class="pdf-holder">
              <embed :src="fileUrl" />
            </div>
          </div>
        </div>
      </template>
    </naj-box>

    <naj-box v-if="firstDegreeJudgment && firstDegreeJudgment.spid" :title="local.common.firstDegreeJudgment">
      <template lass="attachment-row">
        <div v-if="firstDegreeJudgmentDocument !== null" class="pdf-container">
          <div class="pdf-wrapper">
            <div class="pdf-holder">
              <embed :src="firstDegreeJudgmentFileUrl" />
            </div>
          </div>
        </div>
      </template>
    </naj-box>

    <template>
      <naj-button @click="viewCorrectionDecisions()">
        {{ local.common.correctionDecisions }}
      </naj-button>
    </template>

    <template v-if="judgementDetails.isAppealJudgment">
      <naj-button @click="viewFirstDegreeJudgment()">
        {{ local.common.firstDegreeJudgment }}
      </naj-button>
    </template>
  </naj-modal>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');
import { toHijriDate } from '@/helpers/utils';

export default {
  name: 'JudgementDeliveryInfoModal',
  components: {},
  props: {
    modalVisibility: {
      type: Boolean,
      required: true,
    },
    judgement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      document: null,
      judgementDetails: {},
      showFullScreen: false,
      attachmentId: null,
      toHijriDate,
      firstDegreeJudgment: null,
      firstDegreeJudgmentDocument: null,
      deliveryHeaders: [
        {
          value: 'criminalNo',
          text: this.local.home.judgementDelivery.criminalNumber,
        },
        {
          value: 'deliveryStatus',
          text: this.local.home.judgementDelivery.deliveryStatusHeader,
        },
        {
          value: 'caseTypeName',
          text: this.local.home.judgementDelivery.caseClassification,
        },
        {
          value: 'courtName',
          text: this.local.home.judgementDelivery.circleName,
        },
        {
          value: 'conclusiveDate',
          text: this.local.home.judgementDelivery.conclusiveDate,
          formatter: toHijriDate,
        },
      ],
    };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(this.document, false);
    },
    firstDegreeJudgmentFileUrl() {
      return getBlobUrl(this.firstDegreeJudgmentDocument, false);
    },
    modalTitle() {
      return this.local.home.judgementDelivery.judgementNumber + ': ' + this.judgement.judgementCode;
    },
  },
  watch: {
    modalVisibility(newValue, oldValue) {
      if (newValue == true && oldValue != newValue) {
        this.$refs.renderJudgementDetailsModal.show();
      } else {
        this.$refs.renderJudgementDetailsModal.close();
      }
    },
    judgement(newValue) {
      this.postJudgementDelivery();
    },
  },
  methods: {
    ...mapActions(['getTrustedSourceAttachment', 'deliverJudgement', 'getFirstDegreeJudgement']),
    closeRenderJudgementDetailsModal() {
      this.resetData();
      this.$emit('modalClose');
    },
    resetData() {
      this.loading = false;
    },
    getAttachmentDocument() {
      this.loading = true;

      this.getTrustedSourceAttachment(this.attachmentId)
        .then((attachment) => {
          this.document = `data:application/pdf;base64,${attachment}`;
        })
        .finally(() => (this.loading = false));
    },
    postJudgementDelivery() {
      this.loading = true;
      this.deliverJudgement({
        objectKey: this.judgement.objectKey,
        judgementId: this.judgement.judgementId,
      })
        .then((details) => {
          this.judgementDetails = details.data;
          this.attachmentId = details.data.documentId;
          this.getAttachmentDocument();
        })
        .finally(() => (this.loading = false));
    },
    viewCorrectionDecisions() {
      this.$router.push({
        name: 'CorrectionDecisions',
        params: { objectKey: this.judgement.caseInfoObjectkey },
      });
    },
    viewFirstDegreeJudgment() {
      this.loading = true;
      this.getFirstDegreeJudgement(this.judgement.judgementObjectKey).then((response) => {
        this.firstDegreeJudgment = response.data;
        this.getTrustedSourceAttachment(this.firstDegreeJudgment.spid)
          .then((attachment) => {
            this.firstDegreeJudgmentDocument = `data:application/pdf;base64,${attachment}`;
          })
          .finally(() => (this.loading = false));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-row {
  justify-content: center;
}

.attachment-file-viewer {
  height: 100%;
  width: 100%;
}

.pdf-container {
  width: 100%;
  height: 100%;

  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;

    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;

      .pdf-viewer {
        max-height: 100%;
        display: inline-block;
      }
    }
  }
}

embed {
  width: 100%;
  height: 100%;
  min-height: 500px !important;
  max-height: 600px !important;
}

::v-deep .v-dialog {
  max-height: 80% !important;
  height: 75% !important;
}
::v-deep.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 80% !important;
  height: 75% !important;
}
.judgement-details-contents {
  position: fixed;
  top: 50px;
  z-index: 45498880;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
  margin: 0;
  border-radius: 0;
  height: 75% !important;
}
</style>
